import { cn } from '@/lib/utils'

import { FEATURED_JOB_FORM_DESCRIPTION } from './gating-copy'

export type FeaturedJobFormHelpProps = {
  id: string
  featuredActiveUntil?: string | null
  className?: string
}

function formatFeaturedActiveUntil(isoDate: string): string {
  return new Date(isoDate).toLocaleDateString(undefined, { dateStyle: 'medium' })
}

/** Help copy for the featured job checkbox in the opportunity form. */
export function FeaturedJobFormHelp({
  id,
  featuredActiveUntil,
  className,
}: FeaturedJobFormHelpProps) {
  return (
    <div id={id} className={cn('space-y-1 text-xs text-muted-foreground leading-snug', className)}>
      <p>{FEATURED_JOB_FORM_DESCRIPTION}</p>
      {featuredActiveUntil ? (
        <p className="text-foreground/80">
          Active until {formatFeaturedActiveUntil(featuredActiveUntil)}
        </p>
      ) : null}
    </div>
  )
}
